<rg-loader></rg-loader>
<div *ngIf="appInitialized"
     id="app-content"
     tabindex="-1"
     role="main"
     [ngClass]="{
      'page': true
     }"
>
  <div class='page__header' *ngIf="showHeader | async">
    <app-header></app-header>
  </div>
  <div class='page__content'>
    <router-outlet></router-outlet>
  </div>
  <div *ngIf="showFooter | async" class='page__footer'>
    <app-footer></app-footer>
  </div>

  <app-notifications></app-notifications>
</div>
